import { render, staticRenderFns } from "./tzselect.vue?vue&type=template&id=37d4fa12&scoped=true&lang=pug"
import script from "./tzselect.vue?vue&type=script&lang=js"
export * from "./tzselect.vue?vue&type=script&lang=js"
import style0 from "./tzselect.vue?vue&type=style&index=0&id=37d4fa12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4fa12",
  null
  
)

export default component.exports